"use strict";

require("core-js/modules/web.dom-collections.iterator.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Template = _interopRequireDefault(require("./TestimonialTemplate/Template1"));

var _Template2 = _interopRequireDefault(require("./SocialMedia/Template1"));

var _Template3 = _interopRequireDefault(require("./FAQs/Template1"));

var _Template4 = _interopRequireDefault(require("./Blogs/Template1"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// const TestimonialTemplate1 = lazy(() => import("./TestimonialTemplate/Template1"));
const AddPagesLib = tempId => {
  switch (tempId) {
    case "testimonial":
      return _Template.default;

    case "social_media":
      return _Template2.default;

    case "faq":
      return _Template3.default;

    case "blog":
      return _Template4.default;

    default:
      break;
  }
};

var _default = AddPagesLib;
exports.default = _default;